function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 5a5 5 0 015 5v10a5 5 0 01-5 5H10a5 5 0 01-5-5V10a5 5 0 015-5h10z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20 7H10a3 3 0 00-2.995 2.824L7 10v10a3 3 0 002.824 2.995L10 23h10a3 3 0 002.995-2.824L23 20V10a3 3 0 00-2.824-2.995L20 7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.25 17a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm-8.5-3a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm4.5-5.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z"
});

function SvgQInteractiveCodapTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQInteractiveCodapTypeIcon;